import React, { Component } from 'react';
import TitleWithContent from '../common/TitleWithContent';
import { BoxWrapper } from '../common/style';
import EnergyChart from '../graph/Graph';
import PS from '../../PlantList/MonitoringApiService';
import MS from '../../../commons/services/Moment';
import { filterRecentData, getMockBatteryCharge, getMockBatteryDischarge, getMockDemand, getMockSolar } from '../graph/MOCK';
import { withTranslation } from 'react-i18next';

class EnergyMonitoring extends Component {
  constructor(props) {
    super(props);
    this.state = {
      batteryChargeSeries: [],
      batteryDischargeSeries: [],
      demandSeries: [],
      solarPredictionSeries: [],
      solarSeries: [],
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.inverterList !== this.props.inverterList) {
      this.getSolarStat();
    }

    if (prevProps.deviceKey !== this.props.deviceKey) {
      this.getCarrierStat();
    }

    if (prevProps.batteryKey !== this.props.batteryKey) {
      this.getBatteryStat();
    }
  }

  async getSolarStat() {
    const { inverterList } = this.props;
    const inverterSerialNos = inverterList.map(inverter => inverter.inverterNo);
    
    // const param = {
    //   isPeriod: false,
    //   inverterSerialNos,
    //   groupCols: ['hh'],
    //   dateType: "ymd",
    //   date: getSearchDate(),
    // }

    const invParam = {
      inverterSerialNos,
      date: MS.current("YYYY-MM-DD"),
    }

    // 실제 데이터 조회
    // const res = await PS.getPowerList(param);
    try {
      if (!inverterSerialNos || inverterSerialNos.length === 0) return;
      const invRes = await PS.getEmsInvData(invParam);
      if (!invRes || invRes.length === 0) {
        this.setState({
          solarSeries: [],
        });
        return;
      }
      const sortedList = invRes.sort((a, b) => a._id - b._id);
      const solarSeries = sortedList.map(data => {
        return {
          hh: data._id,
          data: data?.day_accumulation_power.toFixed(2) || 0,
        }
      })
  
      this.setState({
        solarSeries: filterRecentData(solarSeries),
      });
    } catch (error) {
      console.error(error);
      this.setState({
        solarSeries: [],
      })
    }

    // 모킹 데이터 조회
    // const mockSolar = await getMockSolar();

    // this.setState({
    //   solarSeries: mockSolar,
    // });
    
  }

  async getCarrierStat() {
    const { deviceKey } = this.props;
    const param = {
      carrierSerialNos: deviceKey,
      date: MS.current("YY-MM-DD"),
      dateType: "ymd",
    }

    try {
      // 실제 데이터 조회
      if (!deviceKey || deviceKey.length === 0) return;
      const res = await PS.getCarrierChart(param);
      const carrierSeries = res?.map(data => {
        return {
          hh: data?._id?.hh,
          data: data?.total_cons_power,
        }
      });
  
      this.setState({
        demandSeries: filterRecentData(carrierSeries),
      });

      // 모킹 데이터 조회
      // const mockDemand = await getMockDemand();
      // this.setState({
      //   demandSeries: mockDemand,
      // });
    } catch (error) {
      console.error(error);
    }
  }

  async getBatteryStat() {
    const { batteryKey } = this.props;
    const param = {
      batterySerialNos: batteryKey,
      date: MS.current("YYYY-MM-DD"),
    }

    try {
      // 실제 데이터 조회
      if (!batteryKey || batteryKey.length === 0) return;

      const res = await PS.getEmsBatteryData(param);
      if (!res || res.length === 0) {
        this.setState({
          batteryChargeSeries: [],
          batteryDischargeSeries: [],
        });
        return;
      }
      const sortedEmsBatteryData = res.sort((a, b) => Number(a._id) - Number(b._id));
      const batteryChargeSeries = sortedEmsBatteryData.map(data => {
        return {
          hh: data._id,
          data: data.hh_ed1_charge_wattage.toFixed(0),
        }
      })
      const batteryDischargeSeries = sortedEmsBatteryData.map(data => {
        return {
          hh: data._id,
          data: data.hh_ed2_discharge_wattage.toFixed(0),
        }
      })
      // 모킹 데이터 조회
      // const batteryChargeSeries = await getMockBatteryCharge();
      // const batteryDischargeSeries = await getMockBatteryDischarge();

      this.setState({
        batteryChargeSeries: batteryChargeSeries,
        batteryDischargeSeries: batteryDischargeSeries,
      });
      
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    const {
      solarSeries,
      solarPredictionSeries,
      demandSeries,
      batteryChargeSeries,
      batteryDischargeSeries,
    } = this.state;
    const { t } = this.props;
    return (
      <TitleWithContent title={t('key122')}>
        <BoxWrapper height={"335px"}>
          <EnergyChart 
            solarSeries={solarSeries}
            solarPredictionSeries={solarPredictionSeries}
            demandSeries={demandSeries}
            batteryChargeSeries={batteryChargeSeries}
            batteryDischargeSeries={batteryDischargeSeries}
          />
        </BoxWrapper>
      </TitleWithContent>
    )
  }
}

export default withTranslation()(EnergyMonitoring);


function getSearchDate() {
  const currentDate = new Date();

  // yyyy-MM-dd 포맷으로 변환
  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  return formatDate(currentDate);
}